import React, { useLayoutEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Footer from './Footer';
import styles from './AdminLayout.module.scss';

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const mainRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // El scroll pertenece al contenido del layout, no a window.
    if (mainRef.current) mainRef.current.scrollTop = 0;
  }, [pathname]);

  const toggleSidebar = () => setCollapsed(!collapsed);

  return (
    <div className={`${styles['admin-layout']} ${collapsed ? styles.collapsed : ''}`}>
      {/* <Sidebar collapsed={collapsed} toggleSidebar={toggleSidebar} /> */}

      {/* Backdrop: solo visible en móvil cuando sidebar está abierto */}
      {/* {!collapsed && (
        <div
          className={styles['sidebar-backdrop']}
          onClick={toggleSidebar} // ← cerrar al tocar fuera
        />
      )} */}

      <div className={styles['admin-layout__content']}>
        <Navbar onMenuToggle={toggleSidebar} /> {/* ← pasar el toggle */}
        <main ref={mainRef} className={styles['admin-layout__main']}>
          {children}
          <Footer />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
